module.exports = __webpack_public_path__ + "static/media/Secrets_gif.63039a4e.gif";